import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconCheckCircle = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M1.875 10C1.875 5.5125 5.5125 1.875 10 1.875C14.4875 1.875 18.125 5.5125 18.125 10C18.125 14.4875 14.4875 18.125 10 18.125C5.5125 18.125 1.875 14.4875 1.875 10ZM13.1442 7.24333C13.0776 7.19517 13.0022 7.1606 12.9223 7.14162C12.8423 7.12263 12.7594 7.11958 12.6783 7.13266C12.5972 7.14574 12.5194 7.17469 12.4495 7.21785C12.3796 7.261 12.3189 7.31752 12.2708 7.38417L9.27333 11.535C9.25497 11.5604 9.23111 11.5814 9.20353 11.5963C9.17595 11.6112 9.14536 11.6197 9.11404 11.6211C9.08271 11.6226 9.05147 11.6169 9.02264 11.6046C8.9938 11.5923 8.96812 11.5736 8.9475 11.55L7.6925 10.1167C7.63914 10.0527 7.57354 10.0001 7.49955 9.96185C7.42556 9.92361 7.34467 9.90055 7.26164 9.89402C7.17861 9.88749 7.09511 9.89762 7.01605 9.92381C6.93699 9.95001 6.86397 9.99174 6.80126 10.0466C6.73856 10.1014 6.68745 10.1682 6.65092 10.243C6.6144 10.3179 6.59321 10.3993 6.58859 10.4824C6.58396 10.5656 6.59601 10.6488 6.62402 10.7273C6.65202 10.8057 6.69542 10.8777 6.75167 10.9392L8.00667 12.3733C8.15112 12.5384 8.33096 12.6688 8.53279 12.7548C8.73462 12.8408 8.95325 12.8801 9.17239 12.8698C9.39153 12.8596 9.60553 12.8 9.79846 12.6956C9.99138 12.5912 10.1583 12.4445 10.2867 12.2667L13.2842 8.11667C13.3324 8.05015 13.367 7.97478 13.386 7.89488C13.4051 7.81497 13.4082 7.73209 13.3952 7.65098C13.3822 7.56986 13.3533 7.49211 13.3103 7.42216C13.2672 7.35222 13.2107 7.29145 13.1442 7.24333Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
IconCheckCircle.displayName = "IconCheckCircle";

export { IconCheckCircle };
